export interface VerificationCodeInputProps {
  value: string;
  onChange: (code: string) => void;
  /** Enter submits, the same as it does in the backup-code field. Filling the last box does not. */
  onSubmit: VoidFunction;
  hasError?: boolean;
}

export const VERIFICATION_CODE_LENGTH = 6;

/**
 * The code is one string with a character per box; trailing empties are trimmed, so a partly typed code is just
 * its digits.
 */
export interface CodeEdit {
  code: string;
  focusIndex: number;
}
